import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "grid grid-cols-2 gap-2 my-2"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import AchievementComponent from "@/modules/archiements/components/Achievement.vue";
import { app } from "@/di";
import { TYPES } from "@/modules/archiements/types";
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const achievements = ref();
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      achievements.value = await app.get(TYPES.AchievementHandler).all();
    })), __temp = await __temp, __restore(), __temp);
    const onClickTakeReward = async achievement => {
      await app.get(TYPES.Rewarder).rewardAchievement(achievement);
      await refresh();
    };
    return (_ctx, _cache) => {
      const _component_NEmpty = _resolveComponent("NEmpty");
      return _openBlock(), _createBlock(DefaultInGameLayout, {
        back: ""
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('achievements')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [achievements.value.length === 0 ? (_openBlock(), _createBlock(_component_NEmpty, {
          key: 0
        })) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(achievements.value, achievement => {
          return _openBlock(), _createBlock(AchievementComponent, {
            key: achievement.id,
            achievement: achievement,
            "onClick:takeReward": $event => onClickTakeReward(achievement)
          }, null, 8, ["achievement", "onClick:takeReward"]);
        }), 128))])]),
        _: 1
      });
    };
  }
});